import { isBrowser } from '../utils';

const MEMORY = new Map<string, string>();

export function storageGet(key: string): string | null {
  if (!isBrowser()) return MEMORY.get(key) ?? null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return MEMORY.get(key) ?? null;
  }
}

export function storageSet(key: string, value: string): void {
  MEMORY.set(key, value);
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* ignore quota / private mode */
  }
}

export function storageRemove(key: string): void {
  MEMORY.delete(key);
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
